import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getBookingList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-bookings?page=" + actions.page
        : apiUrl + "/opa-bookings" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_BOOKING_RESPONSE_GET",
      value: response,
      monthKey: actions.monthKey || null,
    });
  } catch (error) {
    yield put({ type: "LIST_BOOKING_RESPONSE_GET", value: error });
  }
}

function* getBooking(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-booking/"
        : apiUrl + "/opa-booking/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "BOOKING_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "BOOKING_RESPONSE_GET", value: error });
  }
}

function* updateBooking(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataBooking),
    };

    let url = apiUrl + "/opa-booking-patch/" + actions.booking_uuid;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if ((response.status = 200)) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* cancelBooking(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-booking-cancel/" + actions.bookingId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions, false);
    yield put({
      type: "BOOKING_RESPONSE_CANCEL",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_CANCEL",
      value: { ...error, responseStatus: "error" },
    });
  }
}

function* resendConfirmationBooking(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-booking-confirmation-email/" + actions.bookingId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "GET", url, requestOptions, false);

    yield put({
      type: "BOOKING_RESPONSE_RESEND",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_RESEND",
      value: { ...error, responseStatus: "error" },
    });
  }
}

function* refundBooking(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-booking-refund/" + actions.bookingId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions, false);
    yield put({
      type: "BOOKING_RESPONSE_REFUND",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_REFUND",
      value: { ...error, responseStatus: "error" },
    });
  }
}

//PAYMENT NOW

function* paymentNowBooking(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: "",
    };

    let url = apiUrl + "/opa-booking-payment/" + actions.bookingId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.error === undefined) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PAYMENT_NOW_BOOKING",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PAYMENT_NOW_BOOKING",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

// NOTE/TASK

function* addBookingNote(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataNote),
    };

    let url = apiUrl + "/opa-booking-note/" + actions.booking_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_NOTE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_NOTE_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* updateBookingNote(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataNote),
    };

    let url =
      apiUrl +
      "/opa-booking-note/" +
      actions.booking_uuid +
      "/" +
      actions.note_uuid;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updated) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_NOTE_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_NOTE_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteBookingNote(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataNote),
    };

    let url =
      apiUrl +
      "/opa-booking-note/" +
      actions.booking_uuid +
      "/" +
      actions.note_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_NOTE_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_NOTE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingNotesList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-booking-notes/" + actions.booking_uuid;

    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "GET", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.totalCount) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_NOTES_RESPONSE_GET",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_NOTES_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingMetasList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-booking-metas/" + actions.booking_uuid + "?page_size=1000";

    if (enviromentUrl !== "") {
      url += `&env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "GET", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.totalCount) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_METAS_RESPONSE_GET",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_METAS_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingNote(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl +
      "/opa-booking-note/" +
      actions.booking_uuid +
      "/" +
      actions.note_uuid;

    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_NOTE_RESPONSE_GET",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_NOTE_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

// LOGS

function* addBookingLog(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataLog),
    };

    let url = apiUrl + "/opa-booking-log/" + actions.booking_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_LOG_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_LOG_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* updateBookingLog(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataLog),
    };

    let url =
      apiUrl +
      "/opa-booking-log/" +
      actions.booking_uuid +
      "/" +
      actions.log_uuid;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updated) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_LOG_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_LOG_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteBookingLog(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formDataLog),
    };

    let url =
      apiUrl +
      "/opa-booking-log/" +
      actions.booking_uuid +
      "/" +
      actions.log_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_LOG_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_LOG_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingLogsList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-booking-logs/" + actions.booking_uuid;

    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "GET", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_LOGS_RESPONSE_GET",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_LOGS_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingLog(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl +
      "/opa-booking-log/" +
      actions.booking_uuid +
      "/" +
      actions.log_uuid;

    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_LOG_RESPONSE_GET",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BOOKING_LOG_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBookingNotesTasksCount(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-booking/notes/task-count"
        : apiUrl + "/opa-booking/notes/task-count";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_BOOKING_NOTES_TASK_COUNT_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "LIST_BOOKING_NOTES_TASK_COUNT_RESPONSE_GET",
      value: error,
    });
  }
}

function* addBooking(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.formData),
    };

    let url = apiUrl + "/sgw-booking-create";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }
    const response = yield call(apiCall, "POST", url, requestOptions);
    const booking = response?.results?.[0];
    let responseStatus = "warning";
    if (response) {
      if (booking?.extendedBookingData?.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* postAvailability(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.query),
    };

    let url = apiUrl + "/opa-booking-availability";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.productUuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "AVAILABILITY_RESPONSE_POST",
      value: {
        ...response,
        availabilityRequestParams: actions.query,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "AVAILABILITY_RESPONSE_POST",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* resetListBooking() {
  yield put({ type: "BOOKINGS_RESPONSE_RESET" });
}

export function* getSagaBookingList() {
  yield takeEvery("GET_LIST_BOOKING", getBookingList);
}

export function* updateSagaBooking() {
  yield takeEvery("UPDATE_BOOKING", updateBooking);
}

export function* getSagaBooking() {
  yield takeEvery("GET_BOOKING", getBooking);
}

export function* cancelSagaBooking() {
  yield takeEvery("CANCEL_BOOKING", cancelBooking);
}

export function* refundSagaBooking() {
  yield takeEvery("REFUND_BOOKING", refundBooking);
}

export function* processPaymentSagaBooking() {
  yield takeEvery("PROCESS_PAYMENT_BOOKING", paymentNowBooking);
}

export function* resendConfirmationSagaBooking() {
  yield takeEvery("RESEND_CONFIRMATION_BOOKING", resendConfirmationBooking);
}

export function* getSagaBookingMetas() {
  yield takeEvery("GET_METAS_LOG", getBookingMetasList);
}

// NOTE/TASK

export function* addSagaBookingNote() {
  yield takeEvery("ADD_BOOKING_NOTE", addBookingNote);
}

export function* updateSagaBookingNote() {
  yield takeEvery("UPDATE_BOOKING_NOTE", updateBookingNote);
}

export function* deleteSagaBookingNote() {
  yield takeEvery("DELETE_BOOKING_NOTE", deleteBookingNote);
}

export function* getSagaBookingNotesList() {
  yield takeEvery("GET_LIST_BOOKING_NOTES", getBookingNotesList);
}

export function* getSagaBookingNote() {
  yield takeEvery("GET_BOOKING_NOTE", getBookingNote);
}

// LOGS

export function* addSagaBookingLog() {
  yield takeEvery("ADD_BOOKING_LOG", addBookingLog);
}

export function* updateSagaBookingLog() {
  yield takeEvery("UPDATE_BOOKING_LOG", updateBookingLog);
}

export function* deleteSagaBookingLog() {
  yield takeEvery("DELETE_BOOKING_LOG", deleteBookingLog);
}

export function* getSagaBookingLogsList() {
  yield takeEvery("GET_LIST_BOOKING_LOGS", getBookingLogsList);
}

export function* getSagaBookingLog() {
  yield takeEvery("GET_BOOKING_LOG", getBookingLog);
}

export function* resetSagaListBooking() {
  yield takeEvery("RESET_LIST_BOOKING", resetListBooking);
}

export function* getNotesTasksCountSagaBooking() {
  yield takeEvery("GET_NOTES_TASKS_COUNT_BOOKING", getBookingNotesTasksCount);
}

export function* addSagaBooking() {
  yield takeEvery("ADD_BOOKING", addBooking);
}

export function* postSagaAvailabilitys() {
  yield takeEvery("POST_AVAILABILITY", postAvailability);
}

function* requestPaymentBooking(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-booking-request-payment/" + actions.bookingId;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      // Ideally we check response.status === 'success' based on user requirement
      // User said response looks like: { status: "success", ... }
      if (
        response.status === "success" ||
        response.message === "Payment request sent successfully"
      ) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BOOKING_RESPONSE_REQUEST_PAYMENT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BOOKING_RESPONSE_REQUEST_PAYMENT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

export function* requestPaymentSagaBooking() {
  yield takeEvery("REQUEST_PAYMENT_BOOKING", requestPaymentBooking);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
